import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-[#8B97AE]" data-testid="loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  const path = (typeof window !== "undefined" && window.location.pathname) || "";
  const openPaths = ["/change-password", "/verify-email"];
  const isOpen = openPaths.some((p) => path.startsWith(p));
  // Force onboarding for players who haven't completed it — OR whose admin
  // has flagged status=needs_more_info (Iter 192). Both paths land on the
  // same onboarding page; a banner in the page distinguishes the reopen.
  if (
    user.role === "player"
    && (user.onboardingComplete === false || user.status === "needs_more_info")
    && !isOpen
    && !path.startsWith("/onboarding")
  ) {
    return <Navigate to="/onboarding" replace />;
  }
  // Force onboarding for streamers whose email is confirmed but questionnaire
  // is missing (or admin returned it for edits). Streamer-only routes past
  // /streamer stay blocked at the server too (require_verified_streamer).
  if (user.role === "streamer" && user.emailVerified && !user.streamerOnboardingComplete && !isOpen && !path.startsWith("/streamer/onboarding")) {
    return <Navigate to="/streamer/onboarding" replace />;
  }
  return children;
}
